import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/catgridmobile.css";

const categories = [
  { id: 1, name: "Aliments Chien", image: "../figmaAssets/rectangle-67.png" },
  { id: 2, name: "Accessoires Chiens", image: "../figmaAssets/rectangle-68.png" },
  { id: 3, name: "Aliments Chat", image: "../figmaAssets/rectangle-69.png" },
  { id: 4, name: "Accessoires Chat", image: "../figmaAssets/rectangle-70.png" },
  { id: 5, name: "Aliments Oiseaux", image: "../figmaAssets/rectangle-71.png" },
  { id: 6, name: "Accessoires Oiseaux", image: "../figmaAssets/rectangle-72.png" },
  { id: 7, name: "Accessoires Rougeurs", image: "../figmaAssets/rectangle-73.png" },
  { id: 8, name: "Accessoires Poisson", image: "../figmaAssets/rectangle-74.png" },
];

// Hook to get window width
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
}

const CategoryGridMobile = () => {
  const width = useWindowWidth();
  const isMobile = width <= 767;
const navigate = useNavigate();

  // Split categories into chunks of 4
  const chunkArray = (arr, size) =>
    arr.reduce((acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc), []);

  const groupedCategories = chunkArray(categories, 4);

  if (isMobile) {
return (
  <div className="grid-wrapper">
    <div className="scroll-row">
      {categories.map((category) => (
        <div
          key={category.id}
          className="card"
          style={{ backgroundImage: `url(${category.image})` }}
        >
          <div className="card-overlay"
           onClick={() => {
      navigate(`/category/${category.id}/${encodeURIComponent(category.name)}`);
}}>
            <p className="card-title">{category.name}</p>
              <img
                src="../figmaAssets/btn.png"
                alt="Voir plus"
                className="voir-plus-imgm"
              />
              <span className="voir-plus-text">Voir plus</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

  }

  // Desktop: render flat grid
  return (
    <div className="grid-wrapper">
      {categories.map((category) => (
        <div
          key={category.id}
          className="card"
          style={{ backgroundImage: `url(${category.image})` }}
        >
          <div className="card-overlay" onClick={() => {
      navigate(`/category/${category.id}/${encodeURIComponent(category.name)}`);
}}>
            <p className="card-title">{category.name}</p>
              <img src="../figmaAssets/btn.png" alt="Voir plus" className="voir-plus-img" />
              <span className="voir-plus-text">Voir plus</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryGridMobile;
